import { graphql } from "../gql";

export const setClaimAuditTypesMutationDoc = graphql(`
  mutation setClaimAuditTypes($input: SetClaimAuditTypesInput!) {
    setClaimAuditTypes(input: $input) {
      batchClaimStateById {
        claimAuditType
        id
      }
      claimAuditType
      id
    }
  }
`);
